import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
// Custom bus icon
const busIcon = new L.Icon({
    iconUrl: "/assets/images/icons/bus.png", // Remove process.env.PUBLIC_URL
    iconSize: [35, 35],
    iconAnchor: [17, 34], // Adjust for proper positioning
    popupAnchor: [0, -34],
  });
  

// Dummy vehicle data with random locations
const vehicles = [
  { id: "AP16AB1234", lat: 17.385044, lng: 78.486671 },
  { id: "TS08CD5678", lat: 17.437462, lng: 78.448288 },
  { id: "KA01EF9012", lat: 17.421539, lng: 78.490725 },
  { id: "MH12GH3456", lat: 17.415998, lng: 78.474464 },
  { id: "DL09IJ7890", lat: 17.432074, lng: 78.399774 },
  { id: "TN22KL2345", lat: 17.444849, lng: 78.469649 },
  { id: "GJ18MN6789", lat: 17.364045, lng: 78.497571 },
  { id: "RJ30OP0123", lat: 17.392507, lng: 78.442383 },
  { id: "WB42QR4567", lat: 17.401612, lng: 78.472138 },
  { id: "CH54ST8901", lat: 17.411227, lng: 78.482445 },
];

export default function MapComponent() {
  return (
    <div className="container-fluid">
      <MapContainer
        center={[17.385044, 78.486671]} // Default center (Hyderabad)
        zoom={13}
        style={{ height: "80vh", width: "100%" }}
      >
        {/* Tile Layer */}
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">TGG</a> '
        />

        {/* Vehicle Markers */}
        {vehicles.map((vehicle) => (
          <Marker key={vehicle.id} position={[vehicle.lat, vehicle.lng]} icon={busIcon}>
            <Popup>
              <strong>Vehicle No:</strong> {vehicle.id} <br />
              <strong>Location:</strong> {vehicle.lat}, {vehicle.lng}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
